import { AppPage } from 'common/Layout';
import { AcademicCalendar } from 'features/academic-calendar';
import { homeBreadcrumbItem } from 'shared/UI/UIKit/Breadcrumbs';

const breadcrumbs = [
  homeBreadcrumbItem,
  {
    title: 'Календарно-учебный график',
    url: '',
  },
];

export const AcademicCalendarPage = () => {
  return (
    <AppPage
      breadcrumbs={{
        items: breadcrumbs,
      }}
      documentTitle="Календарно-учебный график"
    >
      <AcademicCalendar />
    </AppPage>
  );
};
